import React from 'react';
import { ReactComponent as GraficCategories } from '../assets/grafic-categories.svg';

const Imatge = () => (
  <section className="block block-imatge" id="block-imatge">
    <GraficCategories className="block-imatge-graphic" alt="Gràfic de categories" title="" />
  </section>
);

export default Imatge;
